import { DataGridPro, GridColDef, useGridApiRef } from '@mui/x-data-grid-pro';
import React, { useEffect, useState } from "react";
import { Box, Button, IconButton, InputBase, LinearProgress, Select, MenuItem, FormControl, Grid, Tooltip } from '@mui/material';
import RestoreFromTrashIcon from '@mui/icons-material/RestoreFromTrash';
import useAuth from "../../context/AuthProvider";
import Swal from 'sweetalert2';
import { RiExpandUpDownLine } from "react-icons/ri";
import { StateLoginsModel } from '../../models/StateLoginsModel';
import { AddEditStateLogins } from '../AddEdit/AddEditStateLogins';
import { isUserRoleInclude, readXlsxFile, safeTrim, writeXlsxFile } from '../../helper/utils';
import { apiClient } from '../../helper/api';
import { Search, Autorenew, FileUpload } from "@mui/icons-material";
import { Add } from "@mui/icons-material";
import { GetApp } from "@mui/icons-material";
import moment from 'moment';
import { Autocomplete } from '@mui/material';
import { TextField } from '@mui/material';
import { KeyboardArrowUp, KeyboardArrowDown } from '@mui/icons-material';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

interface Iprops {
    data: StateLoginsModel[];
    fetchData: () => void;
    selectedPartner: string;
    setSelectedPartner: React.Dispatch<React.SetStateAction<string>>;
    selectedLicensee: string;
    setSelectedLicensee: React.Dispatch<React.SetStateAction<string>>;
    selectedState: string;
    setSelectedState: React.Dispatch<React.SetStateAction<string>>;
    sortModel: any;
    setSortModel: React.Dispatch<React.SetStateAction<any>>;
}

interface StateList {
    stateId: string;
    stateName: string;
    postalAbbv: string;
}

export const StateLoginsList: React.FC<Iprops> = ({ 
    data, 
    fetchData, 
    selectedPartner, 
    setSelectedPartner, 
    selectedLicensee, 
    setSelectedLicensee, 
    selectedState, 
    setSelectedState,
    sortModel,
    setSortModel
}) => {
    const initialStateData = { stateId: "", stateName: "", postalAbbv: "" };
    const initialData: StateLoginsModel = {
        stateLoginsId: 0,
        stateId: 0,
        statename: '',
        standardAbbv: '',
        postalAbbv: '',
        partnersId: 0,
        licensee: '',
        website: '',
        username: '',
        password1: '',
        password2: '',
        client: '',
        accountID: '',
    };

    const [states, setStates] = useState<StateList[]>([initialStateData]);
    const [open, setOpen] = React.useState(false);
    const [formData, setFormData] = React.useState(initialData);
    const { user } = useAuth();
    const token = user?.token;
    const [loading, setLoading] = React.useState(false);
    const initialPartnerData = { partnersId: 0, customerName: "" };
    const [partners, setPartnerData] = React.useState([initialPartnerData]);
    const [licenseeNames, setLicenseeNames] = useState<{ rowNum: number; licenseeName: string }[]>([]);
    const apiRef = useGridApiRef();

    const [searchLicensee, setSearchLicensee] = useState('');
    const [searchState, setSearchState] = useState('');
    const [searchPartner, setSearchPartner] = useState('');

    const additionalStates = [
        { stateId: 'CRES', stateName: 'CRES', postalAbbv: 'CRES' },
        { stateId: 'InsCipher', stateName: 'InsCipher', postalAbbv: 'InsCipher' },
        { stateId: 'OPTins', stateName: 'OPTins', postalAbbv: 'OPTins' },
        { stateId: 'Sircon', stateName: 'Sircon', postalAbbv: 'Sircon' },
        { stateId: 'SLAS', stateName: 'SLAS', postalAbbv: 'SLAS' }
    ];

    const additionalClients = [
        { partnersId: 'ApplePie Capital Insurance Solutions', customerName: 'ApplePie Capital Insurance Solutions' },
        { partnersId: 'Cyberwrite', customerName: 'Cyberwrite' },
        { partnersId: 'Insurance Services of San Francisco, Inc. (ISU)', customerName: 'Insurance Services of San Francisco, Inc. (ISU)' },
        { partnersId: "MISC", customerName: "MISC" },
        { partnersId: 'VoloFin', customerName: 'VoloFin' },
        { partnersId: 'Worldwide', customerName: 'Worldwide' }
    ];

    const fetchRequiredData = async (action: string): Promise<any[]> => {
        try {
            const response = await apiClient(action, {
                method: "GET",
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                }),
            });

            return response?.data || [];
        } catch (error) {
            console.error(`Error fetching ${action}:`, error);
            return [];
        }
    };

    const setRequiredStates = async () => {
        setLoading(true);
        try {
            const [partners, licenseeNames, states] = await Promise.all([
                fetchRequiredData('/Partners/getPartners'),
                fetchRequiredData('/States/getStatesLoginsLicenseeNames'),
                fetchRequiredData('/States/getStates'),
            ]);

            setPartnerData([...partners, ...additionalClients]);
            setLicenseeNames(licenseeNames);
            setStates([...states, ...additionalStates]);
        } catch (error) {
            console.error('Error setting required states:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        setRequiredStates();
    }, []);

    const getPartnerFetch = () => {
        setFormData(initialData);
        setOpen(true);
    };

    const handleCopy = (value: string | undefined) => {
        if (!value) return;
        navigator.clipboard.writeText(value);
    };

    const handleEdit = (item: StateLoginsModel) => {
        setFormData(item);
        setOpen(true);
    };

    const handleSearch = ( ) => {
        setSearchLicensee(selectedLicensee);
        setSearchState(selectedState);
        setSearchPartner(selectedPartner.toString());
        setSortModel([{ field: 'licensee', sort: 'asc' }]);
        fetchData();
    };

    const PasswordShow = ({ value }: { value: string }) => {
        const [showPassword, setShowPassword] = useState<boolean>(false);

        const handleShowPassword = () => {
            setShowPassword(!showPassword);
        };

        if (!value) return null;

        return (
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    width: '100%',
                    minHeight: 36,
                    border: '1px solid #e2e8f0',
                    borderRadius: '8px',
                    backgroundColor: '#f8fafc',
                    overflow: 'hidden',
                }}
            >
                <InputBase
                    value={showPassword ? value : '•••••••••••••'}
                    readOnly
                    disabled
                    sx={{
                        flex: 1,
                        fontSize: '14px',
                        color: '#334155',
                        px: 1.5,
                        py: 0.75,
                        '& .MuiInputBase-input': { py: 0.75 },
                    }}
                />
                <Tooltip title={showPassword ? 'Hide password' : 'Show password'} placement="top" arrow>
                    <IconButton
                        size="small"
                        onClick={handleShowPassword}
                        sx={{
                            color: '#64748b',
                            '&:hover': {
                                backgroundColor: '#f1f5f9',
                                color: '#2099d2',
                            },
                        }}
                    >
                        {showPassword ? <VisibilityOffOutlinedIcon fontSize="small" /> : <VisibilityOutlinedIcon fontSize="small" />}
                    </IconButton>
                </Tooltip>
            </Box>
        );
    };

    const columns: GridColDef[] = [
        {
            field: 'licensee',
            type: 'string',
            headerName: 'Licensee',
            hideSortIcons: true,
            renderHeader: (params) => {
                const sortItem = sortModel.find(
                    (item: any) => item.field === 'licensee'
                  );
            
                const isSortedAsc = sortItem?.sort === 'asc';
                const isSortedDesc = sortItem?.sort === 'desc'
                return (
                    <div>
                        <span className="table-card-title">{params.colDef.headerName}</span>
                        {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                    </div>
                )
            },
            flex: 0.8,
            minWidth: 130,
            headerAlign: 'left',
            align: 'left'
        },
        {
            field: 'postalAbbv',
            type: 'string',
            headerName: 'State',
            hideSortIcons: true,
            renderHeader: (params) => {
                const sortItem = sortModel.find(
                    (item: any) => item.field === 'postalAbbv'
                  );
            
                const isSortedAsc = sortItem?.sort === 'asc';
                const isSortedDesc = sortItem?.sort === 'desc'
                return (
                    <div>
                        <span className="table-card-title">{params.colDef.headerName}</span>
                        {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                    </div>
                )
            },
            flex: 0.8,
            minWidth: 100,
            headerAlign: 'left',
            align: 'left'
        },
        {
            field: 'website',
            type: 'string',
            headerName: 'Website',
            hideSortIcons: true,
            renderHeader: (params) => {
                const sortItem = sortModel.find(
                    (item: any) => item.field === 'website'
                  );
            
                const isSortedAsc = sortItem?.sort === 'asc';
                const isSortedDesc = sortItem?.sort === 'desc'
                return (
                <div>
                        <span className="table-card-title">{params.colDef.headerName}</span>
                        {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                    </div>
                )
            },
            flex: 0.8,
            minWidth: 120,
            headerAlign: 'left',
            align: 'left'
        },
        {
            field: 'copyUsername',
            headerAlign: 'center',
            align: 'center',
            headerName: "",
            hideSortIcons: true,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            width: 48,
            minWidth: 48,
            renderCell: (params) => {
                if (!params.row.username) return <></>;
                return (
                    <Tooltip title="Copy username" placement="top" arrow>
                        <IconButton
                            size="small"
                            onClick={() => handleCopy(params.row.username)}
                            sx={{
                                color: '#64748b',
                                '&:hover': {
                                    backgroundColor: '#f1f5f9',
                                    color: '#2099d2',
                                },
                            }}
                        >
                            <ContentCopyIcon fontSize="small" />
                        </IconButton>
                    </Tooltip>
                );
            }
        },
        {
            field: 'username',
            type: 'string',
            headerName: 'Username',
            hideSortIcons: true,
            renderHeader: (params) => {
                const sortItem = sortModel.find(
                    (item: any) => item.field === 'username'
                  );
            
                const isSortedAsc = sortItem?.sort === 'asc';
                const isSortedDesc = sortItem?.sort === 'desc'
                return (
                <div>
                    <span className="table-card-title">{params.colDef.headerName}</span>
                    {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                </div>
            )
            },
            flex: 0.8,
            minWidth: 120,
            headerAlign: 'left',
            align: 'left'
        },
        {
            field: 'password1',
            type: 'string',
            headerName: 'Password1',
            hideSortIcons: true,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            renderHeader: (params) => (
                <div>
                    <span className="table-card-title">{params.colDef.headerName}</span>
                    <RiExpandUpDownLine />
                </div>
            ),
            flex: 0.8,
            minWidth: 150,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => {
                return <PasswordShow value={params.row.password1} />;
            }
        },
        {
            field: 'copyPassword1',
            headerAlign: 'center',
            align: 'center',
            headerName: "",
            hideSortIcons: true,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            width: 48,
            minWidth: 48,
            renderCell: (params) => {
                if (!params.row.password1) return <></>;
                return (
                    <Tooltip title="Copy password" placement="top" arrow>
                        <IconButton
                            size="small"
                            onClick={() => handleCopy(params.row.password1)}
                            sx={{
                                color: '#64748b',
                                '&:hover': {
                                    backgroundColor: '#f1f5f9',
                                    color: '#2099d2',
                                },
                            }}
                        >
                            <ContentCopyIcon fontSize="small" />
                        </IconButton>
                    </Tooltip>
                );
            }
        },
        {
            field: 'password2',
            type: 'string',
            headerName: 'Password2',
            hideSortIcons: true,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            minWidth: 150,
            renderHeader: (params) => {
                const sortItem = sortModel.find(
                    (item: any) => item.field === 'password2'
                  );
            
                const isSortedAsc = sortItem?.sort === 'asc';
                const isSortedDesc = sortItem?.sort === 'desc'
                return (
                <div>
                    <span className="table-card-title">{params.colDef.headerName}</span>
                    {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                </div>
            )
            },
            flex: 0.8,
            headerAlign: 'left',
            align: 'left',
            renderCell: (params) => {
                return <PasswordShow value={params.row.password2} />;
            }
        },
        {
            field: 'copyPassword2',
            headerAlign: 'center',
            align: 'center',
            headerName: "",
            hideSortIcons: true,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            width: 48,
            renderCell: (params) => {
                if (!params.row.password2) return <></>;
                return (
                    <Tooltip title="Copy password" placement="top" arrow>
                        <IconButton
                            size="small"
                            onClick={() => handleCopy(params.row.password2)}
                            sx={{
                                color: '#64748b',
                                '&:hover': {
                                    backgroundColor: '#f1f5f9',
                                    color: '#2099d2',
                                },
                            }}
                        >
                            <ContentCopyIcon fontSize="small" />
                        </IconButton>
                    </Tooltip>
                );
            }
        },
        {
            field: 'notes',
            type: 'string',
            headerName: 'Notes',
            hideSortIcons: true,
            renderHeader: (params) => {
                const sortItem = sortModel.find(
                    (item: any) => item.field === 'notes'
                  );
            
                const isSortedAsc = sortItem?.sort === 'asc';
                const isSortedDesc = sortItem?.sort === 'desc'
                return (
                <div>
                    <span className="table-card-title">{params.colDef.headerName}</span>
                    {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                    </div>
                )
            },
            flex: 0.8,
            minWidth: 150,
            headerAlign: 'left',
            align: 'left'
        },
        {
            field: 'client',
            type: 'string',
            headerName: 'Client',
            hideSortIcons: true,
            renderHeader: (params) => {
                const sortItem = sortModel.find(
                    (item: any) => item.field === 'client'
                  );
            
                const isSortedAsc = sortItem?.sort === 'asc';
                const isSortedDesc = sortItem?.sort === 'desc'
                return (
                <div>
                    <span className="table-card-title">{params.colDef.headerName}</span>
                    {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                </div>
            )
            },
            flex: 0.8,
            minWidth: 190,
            headerAlign: 'left',
            align: 'left'
        },
        {
            field: 'stateLoginsId',
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            headerName: "Action",
            hideSortIcons: true,
            sortable: false,
            filterable: false,
            minWidth: 150,
            disableColumnMenu: true,
            renderCell: (params) => (
                <div>
                    <IconButton
                        color="primary"
                        onClick={() => { handleEdit(params.row); }}
                        sx={{ color: 'rgba(255,255,255,0.9)', '&:hover': { color: '#fff', backgroundColor: 'rgba(32,153,210,0.15) !important' } }}
                    >
                        <Tooltip
                            title="Edit"
                            placement="top"
                            arrow
                        >
                            <EditOutlinedIcon fontSize="small" color="primary" />
                        </Tooltip>
                    </IconButton>

                    <IconButton
                        color="error"
                        onClick={() => { handleDelete(params.row.stateLoginsId); }}
                        sx={{ color: 'rgba(255,255,255,0.9)', '&:hover': { color: '#fff', backgroundColor: 'rgba(211,48,47,0.15) !important' } }}
                    >
                        {params.row.isDeleted ? (
                            <RestoreFromTrashIcon />
                        ) : (
                            <Tooltip
                                title="Delete"
                                placement="top"
                                arrow
                            >
                                <DeleteOutlineOutlinedIcon fontSize="small" color="error" />
                            </Tooltip>
                        )}
                    </IconButton>
                </div>
            )
        },
    ];

    const handleClickAdd = () => {
        getPartnerFetch();
    };

    const handleClose = () => {
        setFormData(initialData);
        fetchData();
        setOpen(false);
    };

    const xlsHeader = [
        'ID',
        'Licensee',
        'State',
        'Website',
        'Username',
        'Password1',
        'Password2',
        'Notes',
        'Client',
        'AccountID'
    ];

    const columnList = [
        {
            id: 0,
            field: 'id',
            xlsHeader: 'ID',
            inputType: 'number',
        },
        {
            id: 0,
            field: 'licensee',
            xlsHeader: 'Licensee',
            inputType: 'string',
        },
        {
            id: 0,
            field: 'postalAbbv',
            xlsHeader: 'State',
            inputType: 'string',
        },
        {
            id: 0,
            field: 'website',
            xlsHeader: 'Website',
            inputType: 'string',
        },
        {
            id: 0,
            field: 'username',
            xlsHeader: 'Username',
            inputType: 'string',
        },
        {
            id: 0,
            field: 'password1',
            xlsHeader: 'Password1',
            inputType: 'string',
        },
        {
            id: 0,
            field: 'password2',
            xlsHeader: 'Password2',
            inputType: 'string',
        },
        {
            id: 0,
            field: 'notes',
            xlsHeader: 'Notes',
            inputType: 'string',
        },
        {
            id: 0,
            field: 'client',
            xlsHeader: 'Client',
            inputType: 'string',
        },
        {
            id: 0,
            field: 'accountID',
            xlsHeader: 'AccountID',
            inputType: 'string',
        },
    ];

    const handleExportXlsx = () => {
        setLoading(true);
        const visibleRows = Array.from(apiRef.current.getVisibleRowModels().values());
        const xlsData: any[][] = [xlsHeader];

        console.log("Data Length:" + visibleRows.length);
        visibleRows.map((item, index) => ({
            id: index + 1,
            ...item,
        })).forEach(item => {
            const update: any[] = [];
            xlsHeader.map(header => {
                const column = columnList.find(c => c.xlsHeader === header);
                if (!column) {
                    update.push('');
                    return;
                }
                const field = column.field as keyof StateLoginsModel;
                const value = item[field];
                if (value === undefined || value === null) {
                    update.push('');
                    return;
                }
                switch (column.inputType) {
                    case 'string':
                        update.push(value.toString());
                        break;
                    case 'number':
                        update.push(+value);
                        break;
                    default:
                        update.push(value.toString());
                        break;
                }
            });
            xlsData.push(update);
        });

        writeXlsxFile(xlsData, 'MISC_StateLogins.xlsx');
        setLoading(false);
    };

    const handleFileChange = async (event: any) => {
        const file = event.target.files[0];
        if (file) {
            setLoading(true);
            await importXLS(file);
            setLoading(false);
        }
    };

    const importXLS = async (file: File) => {
        const sheetsData = await readXlsxFile(file);
        const sheetName = Object.keys(sheetsData)[0];
        const importedData = sheetsData[sheetName];
        const header = importedData[0];
        const stateLookup = new Map(states.map(state => [state.postalAbbv, state.stateId]));
        const updateItems: any[] = [];

        importedData.slice(1).forEach((item: Array<string>) => {
            const stateName = safeTrim(item[header.indexOf('State')]);
            const licensee = safeTrim(item[header.indexOf('Licensee')]);
            const website = safeTrim(item[header.indexOf('Website')]);
            const username = safeTrim(item[header.indexOf('Username')]);
            const password1 = safeTrim(item[header.indexOf('Password1')]);
            const password2 = safeTrim(item[header.indexOf('Password2')]);
            const notes = safeTrim(item[header.indexOf('Notes')]);
            const client = safeTrim(item[header.indexOf('Client')]);
            const accountID = safeTrim(item[header.indexOf('AccountID')]);
            const stateId = stateLookup.get(stateName);
            const customer = partners.find((part) => {
                if (part.customerName?.substring(0, 14) === client?.substring(0, 14)) {
                    return true;
                }
                return false;
            });

            updateItems.push({
                licensee: licensee,
                website: website,
                username: username,
                password1: password1,
                password2: password2,
                notes: notes,
                client: customer?.customerName || client,
                stateId: stateId,
                partnersId: customer ? customer?.partnersId : null,
                stateName: stateName,
                accountID: accountID?.toString() || ''
            });
        });

        const existingRecords = new Set(data.map(eRow =>
            `${safeTrim(eRow.licensee, '')}|${safeTrim(eRow.postalAbbv, '')}|${safeTrim(eRow.website, '')}|${safeTrim(eRow.username, '')}|${safeTrim(eRow.notes, '')}|${safeTrim(eRow.client?.substring(0, 14), '')}|${safeTrim(eRow.password1, '')}|${safeTrim(eRow.password2, '')}|${safeTrim(eRow.accountID, '')}`
        ));

        const newItems: any[] = [];
        const duplicatedItems: any[] = [];
        updateItems.forEach((nRow: any) => {
            const key = `${safeTrim(nRow.licensee, '')}|${safeTrim(nRow.stateName, '')}|${safeTrim(nRow.website, '')}|${safeTrim(nRow.username, '')}|${safeTrim(nRow.notes, '')}|${safeTrim(nRow.client?.substring(0, 14), '')}|${safeTrim(nRow.password1, '')}|${safeTrim(nRow.password2, '')}|${safeTrim(nRow.accountID, '')}`;
            if (!existingRecords.has(key)) {
                newItems.push(nRow);
                return;
            }
            duplicatedItems.push(nRow);
        });

        const sanitizedNewItems = newItems.map(item => Object.fromEntries(
            Object.entries(item).map(([key, value]) => [key, String(value ?? '')]))
        );
        const timeStamp = moment().format('YYYY.M.D');

        await apiClient('/StateLogins/MultiSaveOrUpdate', {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            }),
            body: JSON.stringify(sanitizedNewItems)
        }).then(async (res) => {
            if (!res) return;
            if (res.data && res.data.length > 0) {
                let header = Object.keys(res.data[0]);
                let rows = res.data.map((obj: any) => Object.values(obj));
                writeXlsxFile([header, ...rows], 'Invalid_StateLogins.xlsx');
            }
            if (res.status === true) {
                Swal.fire({
                    title: res.message || "Data Successfully saved",
                    icon: "success",
                    confirmButtonText: "OK",
                });
            } else {
                Swal.fire({
                    title: "Error",
                    text: res.message || "Something went wrong while saving data.",
                    icon: "error",
                    confirmButtonText: "OK",
                });
            }
        })
        .catch((error) => {
            console.error("API error:", error);
            Swal.fire({
                title: "Server Error",
                text: error.message || "Failed to connect to the server.",
                icon: "error",
                confirmButtonText: "OK",
            });
        })
        .finally(() => {
            fetchData();
        });
    };

    const handleDelete = (id: number) => {
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            iconHtml: '<svg width="70" height="70" viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="31" cy="31" r="31" fill="#02A4E3"/><path d="M31.0003 25.6667V31M31.0003 36.3334H31.0137M44.3337 31C44.3337 38.3638 38.3641 44.3334 31.0003 44.3334C23.6365 44.3334 17.667 38.3638 17.667 31C17.667 23.6362 23.6365 17.6667 31.0003 17.6667C38.3641 17.6667 44.3337 23.6362 44.3337 31Z" stroke="white" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
            showCancelButton: true,
            confirmButtonColor: '#02A4E3',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Delete',
            customClass: {
                confirmButton: 'btn-radius',
                cancelButton: 'btn-radius',
                popup: 'card-radius'
            }
        }).then((result) => {
            if (result.isConfirmed) {
                apiClient(`/StateLogins/Delete/${id}`, {
                    headers: new Headers({
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`,
                    }),
                    method: "DELETE",
                })
                .then(async (res) => {
                    if (res.status === true) {
                        fetchData();
                        setOpen(false);
                        Swal.fire(
                            'Deleted!',
                            'The record has been successfully deleted.',
                            'success'
                        );
                    } else {
                        Swal.fire(
                            'Failed!',
                            res?.message || 'Something went wrong while deleting.',
                            'error'
                        );
                    }
                })
                .catch((error) => {
                    console.error(error);
                    Swal.fire(
                        'Failed!',
                        'An unexpected error occurred.',
                        'error'
                    );
                });
            }
        });
    };

    function EditToolbar() {
        return (<>
            <Box sx={{
                //borderBottom: '1px solid #e2e8f0'
            }}>
                
                {/* Action buttons: Import, Add, Export */}
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 1, px: 2, py: 1.5, borderBottom: '1px solid #e2e8f0', backgroundColor: '#fafbfc' }}>
                    <Button
                        variant="contained"
                        size="medium"
                        startIcon={<GetApp />}
                        onClick={() => document.getElementById("importXLS")?.click()}
                        sx={{
                            textTransform: 'none',
                            fontWeight: 600,
                            backgroundColor: '#2099d2',
                            '&:hover': { backgroundColor: '#176990' },
                            px: 2,
                        }}
                    >
                        Import
                    </Button>
                    <input
                        type="file"
                        id="importXLS"
                        style={{ display: 'none' }}
                        onChange={handleFileChange}
                        accept=".xls,.xlsx"
                    />
                    <Button
                        variant="contained"
                        size="medium"
                        startIcon={<Add />}
                        onClick={handleClickAdd}
                        sx={{
                            textTransform: 'none',
                            fontWeight: 600,
                            backgroundColor: '#2099d2',
                            '&:hover': { backgroundColor: '#176990' },
                            px: 2,
                        }}
                    >
                        Add
                    </Button>
                    {isUserRoleInclude(user?.userRoles.split(","), ["Super Admin"]) && (
                        <Button
                            variant="contained"
                            size="medium"
                            startIcon={<FileUpload />}
                            onClick={() => handleExportXlsx()}
                            sx={{
                                textTransform: 'none',
                                fontWeight: 600,
                                backgroundColor: '#2099d2',
                                '&:hover': { backgroundColor: '#176990' },
                                px: 2,
                            }}
                        >
                            Export
                        </Button>
                    )}
                </Box>
            </Box>
        </>);
    }

    return (
        <div style={{ height: 'calc(100vh - 300px)', width: '100%' }}>
            <Box
                sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    alignItems: 'center',
                    gap: 1.5,
                    px: { xs: 4, lg: 2 },
                    py: 2,
                    borderBottom: '1px solid #e2e8f0',
                    backgroundColor: '#fafbfc',
                    minHeight: 56,
                    // mb: 3,
                    marginLeft: { xs: '-24px', lg: '0px' },
                    marginRight: { xs: '-24px', lg: '0px' },
                }}
            >
                <span className="d-flex card-title" style={{ fontWeight: 600, fontSize: '0.9375rem', color: '#334155' }}>
                    State Logins
                </span>
            </Box>
            <Box
                sx={{
                    width: '100%',
                    py: 2,
                    px: 2,
                    backgroundColor: '#ffffff',
                    borderBottom: '1px solid #e2e8f0',
                }}
            >
                <Grid container spacing={2} alignItems="center" className="filter-grid" display="flex">
                        <Grid item>
                            <FormControl size="small" sx={{ minWidth: 250 }}>
                                <Autocomplete
                                    sx={{
                                        marginTop: '-4px !important',
                                        '& .MuiAutocomplete-input': { padding: '0px 4px 0px 5px !important' },
                                    }}
                                    value={licenseeNames.find(item => item.licenseeName === selectedLicensee) || null}
                                    onChange={(event, value) => setSelectedLicensee(value?.licenseeName ?? '')}
                                    options={licenseeNames}
                                    getOptionLabel={(option) => option.licenseeName}
                                    renderInput={(params) => (
                                        <TextField
                                            sx={{
                                                '.MuiFormLabel-root.Mui-focused': {
                                                    color: (typeof params.inputProps.value === 'string' && params.inputProps.value.length > 0) ? '#000' : '#cccccc !important',
                                                },
                                                '& .MuiInputBase-root': { marginTop: '5px !important' },
                                                '& .MuiOutlinedInput-root': { padding: '4.5px 9px' },
                                                '& .MuiFormLabel-root': { transform: 'translate(14px, 13px) scale(1)' },
                                                '& .MuiInputLabel-shrink': { transform: 'translate(14px, -2px) scale(0.75)' },
                                            }}
                                            {...params}
                                            label="Select Licensee"
                                            InputLabelProps={{ ...params.InputLabelProps, shrink: (selectedLicensee?.length > 0 || (typeof params.inputProps.value === 'string' && params.inputProps.value.length > 0)) ? true : false }}
                                        />
                                    )}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item>
                            <FormControl size="small" sx={{ minWidth: 250 }}>
                                <Autocomplete
                                    sx={{
                                        marginTop: '-4px !important',
                                        '& .MuiAutocomplete-input': { padding: '0px 4px 0px 5px !important' },
                                    }}
                                    value={states.find(item => item.stateId === selectedState) || null}
                                    onChange={(event, value) => setSelectedState(value?.stateId ?? '')}
                                    options={states}
                                    getOptionLabel={(option) => option.stateName}
                                    renderInput={(params) => (
                                        <TextField
                                            sx={{
                                                '.MuiFormLabel-root.Mui-focused': {
                                                    color: (typeof params.inputProps.value === 'string' && params.inputProps.value.length > 0) ? '#000' : '#cccccc !important',
                                                },
                                                '& .MuiInputBase-root': { marginTop: '5px !important' },
                                                '& .MuiOutlinedInput-root': { padding: '4.5px 9px' },
                                                '& .MuiFormLabel-root': { transform: 'translate(14px, 13px) scale(1)' },
                                                '& .MuiInputLabel-shrink': { transform: 'translate(14px, -2px) scale(0.75)' },
                                            }}
                                            {...params}
                                            label="Select State"
                                            InputLabelProps={{ ...params.InputLabelProps, shrink: (selectedState?.length > 0 || (typeof params.inputProps.value === 'string' && params.inputProps.value.length > 0)) ? true : false }}
                                        />
                                    )}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item>
                            <FormControl size="small" sx={{ minWidth: 250 }}>
                                <Autocomplete
                                    sx={{
                                        marginTop: '-4px !important',
                                        '& .MuiAutocomplete-input': { padding: '0px 4px 0px 5px !important' },
                                    }}
                                    value={partners.find(item => item.partnersId === Number(selectedPartner)) || null}
                                    onChange={(event, value) => setSelectedPartner(value?.partnersId?.toString() ?? '0')}
                                    options={partners}
                                    getOptionLabel={(option) => option.customerName}
                                    renderInput={(params) => (
                                        <TextField
                                            sx={{
                                                '.MuiFormLabel-root.Mui-focused': {
                                                    color: (typeof params.inputProps.value === 'string' && params.inputProps.value.length > 0) ? '#000' : '#cccccc !important',
                                                },
                                                '& .MuiInputBase-root': { marginTop: '5px !important' },
                                                '& .MuiOutlinedInput-root': { padding: '4.5px 9px' },
                                                '& .MuiFormLabel-root': { transform: 'translate(14px, 13px) scale(1)' },
                                                '& .MuiInputLabel-shrink': { transform: 'translate(14px, -2px) scale(0.75)' },
                                            }}
                                            {...params}
                                            label="Select Client"
                                            InputLabelProps={{ ...params.InputLabelProps, shrink: (selectedPartner?.length > 0 || (typeof params.inputProps.value === 'string' && params.inputProps.value.length > 0)) ? true : false }}
                                        />
                                    )}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item>
                            <Button
                                variant="contained"
                                size="medium"
                                onClick={() => handleSearch()}
                                startIcon={<Search />}
                                sx={{
                                    textTransform: 'none',
                                    fontWeight: 600,
                                    backgroundColor: '#2099d2',
                                    '&:hover': { backgroundColor: '#176990' },
                                    px: 2,
                                }}
                            >
                                Search
                            </Button>
                        </Grid>
                        <Grid item>
                            <Button
                                variant="outlined"
                                size="medium"
                                onClick={() => window.location.reload()}
                                startIcon={<Autorenew />}
                                sx={{
                                    textTransform: 'none',
                                    fontWeight: 600,
                                    borderColor: '#e2e8f0',
                                    color: '#475569',
                                    '&:hover': {
                                        borderColor: '#2099d2',
                                        backgroundColor: 'rgba(32, 153, 210, 0.04)',
                                        color: '#176990',
                                    },
                                    px: 2,
                                }}
                            >
                                Refresh
                            </Button>
                        </Grid>
                </Grid>
            </Box>
            <Box
                sx={{
                    height: '100%',
                    width: '100%',
                    borderRadius: '12px',
                    overflow: 'hidden',
                    boxShadow: '0 4px 24px rgba(15, 23, 42, 0.08), 0 1px 3px rgba(15, 23, 42, 0.06)',
                    border: '1px solid #e2e8f0',
                    backgroundColor: '#ffffff',
                    position: 'relative',
                }}
            >
            {loading && (
                <Box
                    position="absolute"
                    top={0}
                    left={0}
                    right={0}
                    bottom={0}
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    sx={{ backgroundColor: "rgba(250, 251, 252, 0.85)", zIndex: 10, border: "1px solid #e2e8f0", borderRadius: 1 }}
                >
                <Box sx={{ width: "100%", maxWidth: 320 }}>
                    <LinearProgress color="info" sx={{ backgroundColor: "#e2e8f0", "& .MuiLinearProgress-bar": { backgroundColor: "#132D3D" } }} />
                    <Box sx={{ mt: 1.5, textAlign: "center" }}>
                        <span style={{ fontSize: "14px", fontWeight: 600, color: "#475569" }}>Loading...</span>
                    </Box>
                </Box>
                </Box>
            )}
            <DataGridPro
                getRowId={(r) => r.stateLoginsId}
                rows={data}
                loading={loading}
                columns={columns}
                style={{ textAlign: 'center' }}
                components={{
                    Toolbar: EditToolbar,
                }}
                apiRef={apiRef}
                onSortModelChange={(newSortModel: any) => setSortModel(newSortModel)}
                sortModel={sortModel}
                sx={{
                    fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
                    border: 'none',
                    fontSize: '14px',
                    color: '#475569',
                    backgroundColor: '#ffffff',
                    '& .MuiDataGridPro-columnHeaderTitle': {
                        whiteSpace: 'normal',
                        lineHeight: 1.35,
                        fontWeight: 600,
                        fontSize: '12px',
                        letterSpacing: '0.05em',
                        textTransform: 'uppercase',
                        color: '#64748b',
                    },
                    '&.MuiDataGrid-root .MuiDataGrid-columnHeader--alignRight .MuiDataGrid-columnHeaderTitleContainer': {
                        pl: 1,
                    },
                    '& .MuiDataGrid-columnHeaders': {
                        backgroundColor: '#f8fafc',
                        borderBottom: '2px solid #e2e8f0',
                        minHeight: '52px !important',
                        maxHeight: '52px !important',
                    },
                    '& .MuiDataGrid-columnHeader': {
                        '&:focus, &:focus-within': { outline: 'none' },
                    },
                    '& .MuiDataGrid-row': {
                        transition: 'background-color 0.15s ease',
                        '&:nth-of-type(even)': {
                            backgroundColor: '#fafbfc',
                        },
                        '&:hover': {
                            backgroundColor: '#f1f5f9 !important',
                        },
                    },
                    '& .MuiDataGrid-cell': {
                        borderBottom: '1px solid #f1f5f9',
                        fontSize: '14px',
                        color: '#334155',
                        overflow: 'visible',
                        whiteSpace: 'normal',
                        lineHeight: 'normal',
                        wordWrap: 'break-word',
                        textOverflow: 'clip',
                        '&:focus': { outline: 'none' },
                    },
                    '& .MuiDataGrid-virtualScroller': {
                        border: 'none',
                    },
                    '& .MuiDataGrid-main': {
                        border: 'none',
                    },
                    '& .MuiDataGrid-footerContainer': {
                        borderTop: '1px solid #e2e8f0',
                        backgroundColor: '#f8fafc',
                        minHeight: 56,
                    },
                    '& .MuiTablePagination-root': {
                        color: '#64748b',
                        fontSize: '13px',
                    },
                    '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
                        marginBottom: 0,
                    },
                    '& .MuiTablePagination-select': {
                        fontSize: '13px',
                        borderRadius: '6px',
                        border: '1px solid #e2e8f0',
                    },
                    '& .MuiIconButton-root': {
                        color: '#64748b',
                        '&:hover': {
                            backgroundColor: '#f1f5f9',
                            color: '#475569',
                        },
                    },
                }}
            />
            </Box>
            {<AddEditStateLogins
                handleClose={handleClose}
                Open={open}
                item={formData}
                initValues={initialData}
                states={states}
                partners={partners}
            />}
        </div>
    );
};